import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const getBorder = props => props.theme.logisterForm.border
const getBackgroundColor = props => props.theme.logisterForm.background
const getPadding = props => props.theme.logisterForm.padding
const getLandscapePadding = props => props.theme.logisterForm.landscapePadding || props.theme.logisterForm.padding

const LogisterFormView = styled.div`
  border: ${getBorder};
  background-color: ${getBackgroundColor};
  padding: ${getPadding};

  ${breakpoint('landscape')`
    padding: ${getLandscapePadding};
  `};
`

export default LogisterFormView
